import React from 'react';
import { ACCOUNT_DETAILS_PATH } from '../../../router/paths';
import { useCustomHistory } from '../../../router/navigation';
import { buildRouterPath } from '../../../router/utils';
import { useWalletService } from '../../../services';
import { AccountCardMenuItem } from '@make-software/csprclick-ui';

export const ViewAccountMenuItem = () => {
  const walletService = useWalletService();
  const history = useCustomHistory();

  const redirectToAccountPage = () => {
    walletService.publicKey &&
      history.push(
        buildRouterPath(
          ACCOUNT_DETAILS_PATH,
          { id: walletService.publicKey },
          undefined
        )
      );
  };

  return <AccountCardMenuItem onViewAccountClick={redirectToAccountPage} />;
};
